import PropTypes from 'prop-types';
import resourcePropType from '../resource/propTypes';

export default PropTypes.shape({
  end: PropTypes.string.isRequired,
  start: PropTypes.string.isRequired,
  resource: resourcePropType.isRequired
});
